import { useState } from 'react';
import type { NavLink } from '../types';
import { useScrollHeader } from '../hooks/useScrollHeader';

const NAV_LINKS: NavLink[] = [
    { href: '#features', label: 'Features' },
    { href: '#how-it-works', label: 'How It Works' },
    { href: '#benefits', label: 'Benefits' },
    { href: '#technology', label: 'Technology' },
    { href: '#our-vision', label: 'Our Vision' },
    { href: '#contact', label: 'Coming Soon', isCTA: true },
];

export const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const isScrolled = useScrollHeader();

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
            const headerHeight = 80;
            const targetPosition = target.getBoundingClientRect().top + window.scrollY - headerHeight;
            window.scrollTo({ top: targetPosition, behavior: 'smooth' });
            setIsMenuOpen(false);
        }
    };

    return (
        <header className={`header ${isScrolled ? 'scrolled' : ''}`} id="header">
            <nav className="nav container" aria-label="Main navigation">
                <a href="#" className="nav__logo" aria-label="MAM Home">
                    <img src="/assets/mam-logo.png" alt="MAM - Magnolia Agentic Medley" className="logo-image" width="120" height="auto" />
                </a>

                <button
                    className="nav__toggle"
                    id="nav-toggle"
                    aria-label="Toggle navigation menu"
                    aria-expanded={isMenuOpen}
                    onClick={toggleMenu}
                >
                    <span className="hamburger"></span>
                </button>

                <ul className={`nav__menu ${isMenuOpen ? 'active' : ''}`} id="nav-menu" role="menubar">
                    {NAV_LINKS.map((link) => (
                        <li key={link.href} role="none">
                            <a
                                href={link.href}
                                className={`nav__link ${link.isCTA ? 'nav__link--cta' : ''}`}
                                role="menuitem"
                                onClick={(e) => handleNavClick(e, link.href)}
                            >
                                {link.label}
                            </a>
                        </li>
                    ))}
                </ul>
            </nav>
        </header>
    );
};